import React, { Component } from 'react';
import axios from 'axios'
import qs from 'querystring'
import styled from 'styled-components'
import { Flex, Box } from 'reflexbox'
import {
  getCookie
} from './scripts/common'
import {
  impressionsTracking,
  failureTracking,
  clickTracking
} from './scripts/tracking'
import noPhoto from './image/icon_no-photo_48x37.png'
import noPhotoTest from './image/ad-no-photo.png'

const COOKIES = {
  LURKER_ID: 'l_id',
  TEST_ID: {
    TESTAB_GROUPS: 'TestAB_Groups'
  }
}

const BASE_URL_REC = 'https://recommendation.olx.com.br/api/rec'

const ImageBox = styled.div`
  background: #FFF;
  border: 1px solid #CCC;
  color: #666;
  display: table-cell;
  height: 86px;
  overflow: hidden;
  text-align: center;
  vertical-align: middle;
  width: 114px;

`
const ImageWrapper = styled.div`
  height: 88px;
  width: 114px;
`

const Image = styled.img`
  max-height: 86px;
  max-width: 114px;
  vertical-align: middle;
`

const Title = styled.h3`
  font-family: Nunito Sans, sans-serif;
  margin: 0;
  color: #38B;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.167em;
  max-height: 42px;
  overflow: hidden;
  width: 93%;
  padding-left: 7%;
`

const Price = styled.p`
  font-family: Nunito Sans, sans-serif;
  margin: 0;
  font-size: 13px;
  padding-left: 7%;
  font-weight: bold;
`

const Link = styled.a`
  height: 96px;
  padding: 5px;
  flex: 1 1 auto;
  display: flex;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    background-color: #e3edf6;
  }
`

const NoPhoto = styled.img`
  display: block;
  height: 37px;
  margin: 0 auto;
  overflow: hidden;
  text-indent: -999px;
  width: 48px;
}
`

const GalleryWrapper = ({ children }) => (
  <div>
    <div className="gallery-content">
      <div className="gallery-head">
        <span className="gallery-title">Galeria</span>
        <a href="javascript:void(0)" title="Sobre Galeria" className="more-info-gallery-link" rel=".module_lightbox.gallery" lurker="gallery_info">
          Colocar anúncio aqui
           </a>
      </div>
      {children}
    </div>
  </div>
)

const ImageWrapperTest = styled.div`
  width: 100%;
  display: table;
  position: relative;
  margin: 0 0 16px;
  text-align: center;
  background-color: #f6f6f6;
  border-radius: 8px;
`

const ImageBoxTest = styled.div`
  height: 216px;
  width: 100%;
  overflow: hidden;
  text-align: center;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  border-radius: 8px;
`

const ImageTest = styled.img`
  height: 216px;
  max-width: 100%;
  vertical-align: middle;
  display: inline;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  object-fit: cover;
`

const LinkTest = styled.a`
  cursor: pointer;
  text-decoration: none;
  width: 100%;

  &:hover .imageWrapper{
    box-shadow: 0 3px 6px 0 rgba(53,59,80,.13);
  }
`

const TitleTest = styled.h3`
  font-family: Nunito Sans, sans-serif;
  margin: 0 0 4px;
  color: #4a4a4a;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.43em;
  max-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const PriceTest = styled.p`
  font-family: Nunito Sans, sans-serif;
  margin: 0;
  font-size: 16px;
  font-weight: normal;
  color: #4a4a4a;
  line-height: 1.5em;
  height: 24px;
`
const NoPhotoTest = styled.img`
  display: block;
  margin: 0 auto;
  overflow: hidden;
  text-indent: -999px;
  max-height: 74px;
  max-width: 110px;
}
`

const GalleryWrapperTest = ({ children }) => (
  <div>
    <div className="gallery-content">
      <div className="gallery-head">
        <div className="gallery-header-title">
          <svg width="27px" height="32px" viewBox="0 0 27 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Interfaces" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="Listing-RJ---New-Destaques" transform="translate(-699.000000, -516.000000)">
                <g id="Group-8" transform="translate(699.000000, 516.000000)">
                  <g id="ic-galeria">
                    <polygon id="Rectangle" fill="#17B5DB" points="0 0 27 0 27 32 13.1953125 26 0 32"></polygon>
                    <path d="M19,19.7298361 C19,19.8790164 18.8741707,20 18.7188049,20 L5.28119512,20 C5.126,20 5,19.8790164 5,19.7298361 L5,10.2701639 C5,10.1209836 5.126,10 5.28119512,10 L18.7186341,10 C18.8741707,10 19,10.1209836 19,10.2701639 L19,19.7298361 Z M17.4634146,11.5816393 C17.4634146,11.432459 17.3375854,11.3114754 17.1822195,11.3114754 L6.64704878,11.3114754 C6.49185366,11.3114754 6.36585366,11.432459 6.36585366,11.5816393 L6.36585366,18.4183607 C6.36585366,18.567541 6.49185366,18.6885246 6.64704878,18.6885246 L17.1820488,18.6885246 C17.3375854,18.6885246 17.4634146,18.567541 17.4634146,18.4183607 L17.4634146,11.5816393 Z M22.2968219,6.27426811 L22.9992209,16.5327958 C23.0097595,16.6941158 22.9126285,16.8347584 22.7540223,16.8454536 L20.5338866,17 L20.5338866,15.5277988 L21.2127493,15.4737878 C21.3715312,15.4630925 21.4445989,15.3185284 21.4338847,15.1572084 L20.9496351,7.82169259 C20.9387452,7.66055082 20.7999867,7.5209778 20.6413805,7.53185131 L11.3840819,8.1297158 L8.06336307,8.1297158 L8.00065829,7.21491538 C7.98994403,7.0534171 8.11131379,6.94539507 8.27009565,6.93452157 L21.9883917,6.00064795 C22.1473492,5.9899527 22.2861076,6.11294808 22.2968219,6.27426811 Z" id="Combined-Shape" fill="#FFFFFF" fillRule="nonzero"></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
          <span className="gallery-title">
            Galeria
          </span>
        </div>
        <a href="javascript:void(0)" title="Sobre Galeria" className="more-info-gallery-link" rel=".module_lightbox.gallery" lurker="gallery_info">
          Coloque seu anúncio nesta galeria
        </a>
      </div>
      {children}
    </div>
  </div >
)

class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      recState: null,
      algorithm: '',
      algorithm_version: ''
    }
  }

  componentWillMount() {
    var checkExist = setInterval(() => {
      const dataLayer = window.dataLayer || []
      const template_vars = window.template_vars || []
      if (dataLayer.length) {
        const lurker_id = this.getLurkerId()
        const test_id = (this.getTestABGroup("listingfacelift_gallery") || this.getTestABGroup("listingfacelift_total")) ? '' : this.getTestABGroupVariant("newGridList")
        const region_id = this.getRegionId(dataLayer[0])
        const subcategory_id = this.getSubcategoryId(dataLayer[0])
        const state_id = this.getStateId(dataLayer[0])
        const zone_id = this.getZoneId(dataLayer[0])
        const category_id = this.getParentCategoryId(dataLayer[0])
        const sd_id = Array.prototype.slice.apply(document.querySelectorAll("input[name=sd][type=hidden]")).map(function (item) { return item.value })
        const keyword_search = this.getKeywordSearch(template_vars)

        const galleryProperties = {
          lurker_id,
          test_id,
          region_id,
          subcategory_id,
          category_id,
          state_id,
          zone_id,
          sd_id,
          keyword_search
        }

        axios.get(`${BASE_URL_REC}/?custom_tag=listing_gallery&${qs.stringify(galleryProperties)}`)
          .then(({ data }) => {

            let response

            if (Array.isArray(data)) {
              response = data[0]
            } else {
              response = data
            }

            if (response.content.length !== 0) {
              impressionsTracking("gallery", "listing-gallery-ads", data.algorithm, data.algorithm_version, data.content);
            }

            this.setState({
              recState: response.content,
              algorithm: response.algorithm,
              algorithm_version: response.algorithm_version
            })
          })
          .catch(error => {
            if (error.response) {
              failureTracking("gallery", JSON.stringify(error.response.status))
            }
          })
        clearInterval(checkExist);
      }
    }, 200)
  }

  getLurkerId = () => getCookie(COOKIES.LURKER_ID)
  getRegionId = obj => this.getValueFromNestedObject(['page', 'detail', 'region_id'], obj)
  getStateId = obj => this.getValueFromNestedObject(['page', 'detail', 'state_id'], obj)
  getSubcategoryId = obj => this.getValueFromNestedObject(['page', 'detail', 'category_id'], obj)
  getParentCategoryId = obj => this.getValueFromNestedObject(['page', 'detail', 'parent_category_id'], obj)
  getZoneId = obj => this.getValueFromNestedObject(['page', 'searchDetail', 'subRegionID'], obj)
  getKeywordSearch = obj => this.getValueFromNestedObject(['q'], obj)

  getTestABGroupVariant = (testAB) => {
    const testAB_Groups = getCookie(COOKIES.TEST_ID.TESTAB_GROUPS)
    let variant = ''
    if (testAB_Groups) {
      if (testAB_Groups.indexOf(testAB) >= 0) {
        let testABGroups = testAB_Groups.split('.')
        variant = testABGroups
          .filter(item => item.includes(testAB))
          .map(item => item.split("_").pop())
      }
    }
    return variant
  }

  getTestABGroup = (testAB) => {
    const testAB_Groups = getCookie(COOKIES.TEST_ID.TESTAB_GROUPS)
    let isTestAB = false
    if (testAB_Groups) {
      isTestAB = testAB_Groups.indexOf(testAB) >= 0;

    }
    return isTestAB
  }

  getPadding = () => {
    let isTestABnewGridList = this.getTestABGroup("newGridList_Body") || this.getTestABGroup("newGridList_HeaderBody")

    if (isTestABnewGridList) {
      return { paddingLeft: '10px' }
    } else {
      return { paddingRight: '10px' }
    }
  }

  getValueFromNestedObject = (s, o) =>
    s.reduce((prev, cur) => ((prev && prev[cur]) ? prev[cur] : null), o)

  handleClick(ad, adPosition) {
    clickTracking('gallery', this.state.algorithm, this.state.algorithm_version, ad.list_id, adPosition);
  }

  onImgError(e, noPhoto) {
    if (e.target.src !== noPhoto) {
      e.target.style.height = '74px';
      e.target.src = noPhoto;
    }
    return true;
  }

  formatPrice(price) {
    let number = parseInt(price.replace(/[\D]+/g, ''), 10).toFixed(2)
    let x = number.split('.')
    let x1 = x[0]
    const rgx = /(\d+)(\d{3})/
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, `$1.$2`)
    }
    return `R$ ${x1}`
  }

  render() {
    if (!this.state.recState || Object.keys(this.state.recState).length === 0) return false

    let isTestABlistingfacelift = this.getTestABGroup("listingfacelift_gallery") || this.getTestABGroup("listingfacelift_total")
    if (isTestABlistingfacelift) {
      return (
        <GalleryWrapperTest>
          <Flex p={0} align='center' style={{ marginRight: '-24px' }}>
            {this.state.recState.map((ad, i) => {
              return (
                <Box w={1 / 3} style={{ overflow: 'hidden', marginRight: '24px', padding: '0 3px', flex: 'inherit' }} auto flex key={i} alt={ad.subject} >
                  <LinkTest href={ad.ad_url} onClick={() => this.handleClick(ad, i)}>
                    <ImageWrapperTest className="imageWrapper">
                      <ImageBoxTest>
                        {(ad.image_url) ?
                          <ImageTest className="image" src={ad.image_url} onError={(e) => this.onImgError(e, noPhotoTest)} />
                          :
                          <NoPhotoTest src={noPhotoTest}></NoPhotoTest>
                        }
                      </ImageBoxTest>
                    </ImageWrapperTest>
                    <TitleTest>{ad.subject}</TitleTest>
                    <PriceTest>{(ad.price) ? this.formatPrice(ad.price) : ''}</PriceTest>
                  </LinkTest>
                </Box>
              )
            })}
          </Flex>
        </GalleryWrapperTest>
      );
    }

    return (
      <GalleryWrapper>
        <Flex p={0} align='center' style={{ padding: '10px 0 10px 0' }}>
          {this.state.recState.map((ad, i) => {
            return (
              <Box w={1 / 3} style={{ overflow: 'hidden' }} auto flex key={i} alt={ad.subject}>
                <Link href={ad.ad_url} onClick={() => this.handleClick(ad, i)}>
                  <Box w={1 / 2}>
                    <ImageWrapper>
                      <ImageBox>
                        {(ad.image_url) ?
                          <Image className="image" src={ad.image_url} onError={(e) => this.onImgError(e, noPhoto)} />
                          :
                          <NoPhoto src={noPhoto}></NoPhoto>
                        }
                      </ImageBox>
                    </ImageWrapper>
                  </Box>
                  <Box w={1 / 2} style={this.getPadding()}>
                    <Title>{ad.subject}</Title>
                    <Price>{ad.price}</Price>
                  </Box>
                </Link>
              </Box>
            )
          })}
        </Flex>
      </GalleryWrapper>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js